import { Result, ResultProps, Spin, Typography } from "antd";
import { FC, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { centerContainerStyle } from "./styles";

interface OidcStateProp {
  heightOverride?: string;
  icon: OidcStateIcon;
  state: string;
}

type OidcStateIcon = ResultProps["status"] | "loading";
const OidcState: FC<OidcStateProp> = ({ state, icon, heightOverride }) => {
  useTranslation();

  const wrapperStyle = useMemo(
    () => ({
      ...centerContainerStyle,
      ...heightOverride ? { height: heightOverride } : {},
    }),
    [heightOverride],
  );

  const iconEl = useMemo(
    () => icon === "loading" ? <Spin size="large"/> : undefined,
    [icon],
  );
  const status = useMemo(
    () => icon !== "loading" ? icon : undefined,
    [icon],
  );

  return (
    <div style={wrapperStyle}>
      <Result
        icon={iconEl}
        status={status}
        title={(
          <Typography.Title level={2}>
            <Trans ns="common" i18nKey={`oidc.oidcState.${state}.title`}/>
          </Typography.Title>
        )}
        extra={(
          <Typography.Text>
            <Trans ns="common" i18nKey={`oidc.oidcState.${state}.message`}/>
          </Typography.Text>
        )}
      />
    </div>
  );
};

export const OidcAuthenticating: FC = () => (
  <OidcState icon="loading" state="authenticating"/>
);

export const OidcAuthenticationError: FC = () => (
  <OidcState icon="error" state="authenticationError"/>
);

export const OidcCallbackSuccess: FC = () => (
  <OidcState icon="loading" state="callbackSuccess"/>
);

export const OidcLoading: FC = () => (
  <OidcState icon="loading" state="loading"/>
);

export const OidcLoggingOut: FC = () => (
  <OidcState icon="loading" state="loggingOut"/>
);

export const OidcSessionLost: FC = () => (
  <OidcState icon="loading" state="sessionLost"/>
);

export const OidcWaiting: FC = () => (
  <OidcState icon="loading" state="waiting"/>
);

export const Unauthorized: FC = () => (
  <OidcState icon="error" state="unauthorized" heightOverride="100%"/>
);
